import React from 'react'
import {Card} from "reactstrap";
import PizzaCard from '../../components/Graficos/PizzaCard'
import BarrasCard from '../../components/Graficos/BarrasCard'
import LinhaCard from '../../components/Graficos/LinhaCard'
import useGet from '../../lib/useGet'
import Loading from 'lib/loading'

const graficos = {
  PizzaCard,
  BarrasCard,
  LinhaCard
}

const Grafico = ({ title, color, fonte, component }) => {
  const [data, loading] = useGet(fonte, 60000)
  if (loading) {
    return (
      <div>
        <Card>
          <Loading
            tipo='componente'
          />
        </Card>
      </div>
    )
  }
  const Component = graficos[component]
  let nulo = {lojas:['nenhuma'], valores: ['0'], total: ['0']}
 // let fixo =  {lojas:['outra','uma','mais uma'], valores: ['50','60','80'], total: ['500']}
  return (
    <Component
      color={color}
      title={title}
      loading={loading}
     // dados={fixo ? fixo : nulo}
      dados={data.lista ? data.lista : nulo}
    />
  )
}
export default Grafico
